// extracted by mini-css-extract-plugin
export default {"parent":"TermsPage_parent__3R8lj","subParent":"TermsPage_subParent__LrM4c","contact":"TermsPage_contact__eLyP7"};